//@flow
import React, {useState} from 'react';
import {makeStyles, Typography, MenuItem, Grid} from '@material-ui/core';
import CustomSelect from '../../../../../../elements/CustomSelect/CustomSelect';
import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import {colors} from '../../../../../../assets/styles/colors';

import type {FilterRowProps} from '.';
import {useDebounceEffect} from '../../../../../../utils/react';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '.5rem',
    borderRadius: '1rem',
    background: colors.grey200,
  },
}));

const options = [
  {
    value: true,
    label: 'Si',
  },
  {
    value: false,
    label: 'No',
  },
];

export default function OrderCreatedFilter(props: FilterRowProps) {
  const classes = useStyles();
  const {conditions = {}, onChange} = props;

  const {hasPurchased, days} = conditions;

  const [purchased, setPurchased] = useState(hasPurchased ?? true);
  const [daysAmount, setDaysAmount] = useState(days ?? '30');

  useDebounceEffect(
    () => {
      if (!onChange) return;

      onChange({
        hasPurchased: purchased,
        days: Number(daysAmount),
      });
    },
    500,
    [daysAmount, purchased]
  );

  return (
    <Grid container className={classes.root} spacing={1} alignItems="center">
      <Grid item xs={2}>
        <Typography>Clientes que</Typography>
      </Grid>
      <Grid item xs={2}>
        <CustomSelect
          fullWidth
          className={classes.select}
          value={purchased}
          onChange={e => setPurchased(e.target.value)}
        >
          {options.map(el => (
            <MenuItem
              key={'text-color-' + el.label}
              value={el.value}
              className={classes.itemSelectFontColor}
            >
              <Typography>{el.label}</Typography>
            </MenuItem>
          ))}
        </CustomSelect>
      </Grid>
      <Grid item xs={4}>
        <Typography>han comprado en los ultimos</Typography>
      </Grid>
      <Grid item xs={2}>
        <CustomTextField
          type="number"
          fullWidth
          value={daysAmount}
          onChange={e => setDaysAmount(e.target.value)}
        />
      </Grid>
      <Grid item xs={1}>
        <Typography>Dias</Typography>
      </Grid>
    </Grid>
  );
}
